import { selectVisibleRoutesBySelectedTaskFieldSeasonId } from 'app/containers/Map/slice/selectors';
import { useCreateOrUpdateTaskRoutes } from 'app/containers/Task/pages/CreateOrUpdateTask/hooks/useCreateOrUpdateTaskRoutes';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { scrollToElementById } from 'utils/helpers';

export const useSingleTaskFieldRoutes = () => {
  const params = useParams<{
    taskId: string;
  }>();

  const taskId = Number.isNaN(Number(params.taskId))
    ? undefined
    : Number(params.taskId);
  const fieldSeasonId = useSelector(
    selectVisibleRoutesBySelectedTaskFieldSeasonId,
  );

  const { taskRoutes } = useCreateOrUpdateTaskRoutes({ taskId });

  const visibleRoutes = taskRoutes.filter(
    route => route.fieldSeasonId === fieldSeasonId,
  );

  const onFieldClick = ({
    fieldSeasonId,
    routeId,
  }: {
    fieldSeasonId?: number;
    routeId?: number;
  }) => {
    if (!fieldSeasonId) {
      return;
    }
    scrollToElementById(`routeItem${routeId}`);
  };

  return {
    visibleRoutes,
    onFieldClick,
  };
};
